export const HEADERS_KEYS = {
    applicationKey: "Application-Key",
    contentType: "Content-Type",
    accept: "Accept",
    apiKey: "X-Api-Key",
    projectKey: "Project-Key",
    reporterVersion: "Reporter-Version",
};
export const API_BASE_URL = "/api/v1";
export const API_BASE_URL_V2 = "/api/v2";
//# sourceMappingURL=constants.js.map